// // src/components/SignInForm.js
// import React, { useState } from 'react';
// import './SignInForm.css';

// const SignInForm = () => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//     rememberMe: true,
//   });

//     const [modalVisible, setModalVisible] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');

//   const togglePassword = () => setShowPassword(!showPassword);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   };

// const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await fetch('https://pst-file-uploader.finkraftai.com/api/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           email: formData.email,
//           password: formData.password,
//         }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         localStorage.setItem('isLoggedIn', 'true');
//         localStorage.setItem('userEmail', formData.email);
//         window.location.href = '/upload';
//       } else {
//         setModalMessage(data.message);
//         setModalVisible(true);
//       }
//     } catch (err) {
//       console.error("Login error:", err);
//       setModalMessage("Something went wrong. Please try again.");
//       setModalVisible(true);
//     }
//   };



//   return (
//     <>
//     {modalVisible && (
//         <div style={styles.modalOverlay}>
//           <div style={styles.modal}>
//             <h3 style={styles.modalTitle}>Login Info</h3>
//             <p style={styles.modalText}>{modalMessage}</p>
//             <button onClick={() => setModalVisible(false)} style={styles.modalButton}>Close</button>
//           </div>
//         </div>
//       )}
//     <div className="signup-form-container">
//       <h2>Sign In</h2>
//       <p>Enter your credentials to proceed.</p>

//       <form onSubmit={handleSubmit}>
//         <label>
//           Email Address *
//           <input
//             type="email"
//             name="email"
//             placeholder="Enter email address"
//             value={formData.email}
//             onChange={handleChange}
//             required
//           />
//         </label>

//         <label>
//           Password *
//           <div className="password-input">
//             <input
//               type={showPassword ? 'text' : 'password'}
//               name="password"
//               placeholder="Enter password"
//               value={formData.password}
//               onChange={handleChange}
//               required
//             />
//             <button type="button" onClick={togglePassword} className="eye-btn">
//               👁️
//             </button>
//           </div>
//         </label>

//         <div className="signin-options">
//           <div className="remember-me">
//             <input
//               type="checkbox"
//               name="rememberMe"
//               checked={formData.rememberMe}
//               onChange={handleChange}
//             />
//             Keep me signed in
//           </div>
//           <a href="#" className="forgot-link">Forgot Password?</a>
//         </div>

//         <button type="submit" className="submit-btn">Continue</button>

//         <p className="signup-link">
//             Don’t have an account? <a href="/signup">Sign up</a>
//          </p>
//       </form>
//     </div>
//     </>
//   );
// };

// const styles = {
//   container: {
//     fontFamily: 'Arial, sans-serif',
//     padding: '2rem',
//     maxWidth: '400px',
//     margin: 'auto',
//   },
//   form: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '1rem',
//   },
//   input: {
//     padding: '0.75rem',
//     fontSize: '1rem',
//     border: '1px solid #ccc',
//     borderRadius: '5px',
//   },
//   button: {
//     padding: '0.75rem',
//     fontSize: '1rem',
//     backgroundColor: '#007bff',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//   },
//   modalOverlay: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: 'rgba(0, 0, 0, 0.6)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 9999, // ADD this: high z-index to cover everything
//   },
//   modal: {
//     backgroundColor: '#fff',
//     padding: '2rem',
//     borderRadius: '10px',
//     width: '300px',
//     textAlign: 'center',
//     boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
//     zIndex: 10000, // ADD this: modal should be above overlay (optional)
//   },
//   modalTitle: {
//     marginBottom: '1rem',
//   },
//   modalText: {
//     marginBottom: '1.5rem',
//   },
//   modalButton: {
//     padding: '0.5rem 1rem',
//     backgroundColor: '#007bff',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//   }
// };

// export default SignInForm;
// src/components/SignInForm.js
import React, { useState } from 'react';
import './SignInForm.css';

const SignInForm = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: true,
  });

  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const togglePassword = () => setShowPassword(!showPassword);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://pst-file-uploader.finkraftai.com/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userEmail', formData.email);
        window.location.href = '/upload';
      } else {
        setModalMessage(data.message);
        setModalVisible(true);
      }
    } catch (err) {
      console.error("Login error:", err);
      setModalMessage("Something went wrong. Please try again.");
      setModalVisible(true);
    }
  };

  const handleGuestLogin = () => {
    // Save guest login state
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('userEmail', 'guest@domain.com');
    window.location.href = '/upload';
  };

  return (
    <>
      {modalVisible && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3 style={styles.modalTitle}>Login Info</h3>
            <p style={styles.modalText}>{modalMessage}</p>
            <button onClick={() => setModalVisible(false)} style={styles.modalButton}>Close</button>
          </div>
        </div>
      )}

      <div className="signup-form-container">
        <h2>Sign In</h2>
        <p>Enter your credentials to proceed.</p>

        <form onSubmit={handleSubmit}>
          <label>
            Email Address *
            <input
              type="email"
              name="email"
              placeholder="Enter email address"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Password *
            <div className="password-input">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Enter password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <button type="button" onClick={togglePassword} className="eye-btn">
                👁️
              </button>
            </div>
          </label>

          <div className="signin-options">
            <div className="remember-me">
              <input
                type="checkbox"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleChange}
              />
              Keep me signed in
            </div>
            {/* <a href="#" className="forgot-link">Forgot Password?</a> */}
          </div>

          <button type="submit" className="submit-btn">Continue</button>

          {/* Divider with text */}
          <div className="divider">
            <span>or</span>
          </div>

          {/* Guest login button */}
          <button type="button" className="guest-btn" onClick={handleGuestLogin}>
            👤 Continue as Guest
          </button>

          <p className="signup-link">
            Don’t have an account? <a href="/signup">Sign up</a>
          </p>
        </form>
      </div>
    </>
  );
};

const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  modal: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '10px',
    width: '300px',
    textAlign: 'center',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    zIndex: 10000,
  },
  modalTitle: {
    marginBottom: '1rem',
  },
  modalText: {
    marginBottom: '1.5rem',
  },
  modalButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  }
};

export default SignInForm;
